import { extractPathname } from "../extractPathname";

export const validateUrlMatchesRegex =
  (url: string) => (pagePattern: string) => {
    const regex = new RegExp(pagePattern);
    const errorMessage = "Does not match the given URL";
    return regex.test(extractPathname(url)) || errorMessage;
  };
